import { Fragment } from 'react';
import Snippet from '../../components/Snippet/Snippet'
import { colors, sizes } from '../../assets/code-snippets/badge/snip'

const Badge = () => {

    return <Fragment>
        <div className="container fluid py-2" id="intro">
            <div className="container fluid">
                <p className="text xl"><a href="#intro" className="link">&#128279;</a> Badge</p>
            </div>
            <div className="spacer md"></div>
            <div className="row align-items-center">
                <div className="col md-III">
                    <div className="container sm">
                        <Snippet code='<span class="badge">badge</span>' language='html' />
                    </div>
                </div>
                <div className="col md-III">
                    <div className="container sm">
                        <span className="badge">badge</span>
                    </div>
                </div>
            </div>
        </div>


        <div className="container fluid py-2" id="sizes">

            <div className="container fluid">
                <p className="text xl"><a href="#sizes" className="link">&#128279;</a> Badge sizes</p>
            </div>

            <div className="spacer md"></div>

            <div className="row align-items-center">
                <div className="col md-III">
                    <div className="container sm">
                        <Snippet code={sizes} language='html' />
                    </div>
                </div>
                <div className="col md-III">
                    <div className="container sm">
                        <span className="badge sm">badge</span>
                        <span className="badge md">badge</span>
                        <span className="badge lg">badge</span>
                        <span className="badge xl">badge</span>
                    </div>
                </div>
            </div>
        </div>


        <div className="container fluid py-2" id="color-gradients">

            <div className="container fluid">
                <p className="text xl"><a href="#color-gradients" className="link">&#128279;</a> Badge colors & gradients </p>
            </div>

            <div className="spacer md"></div>

            <div className="row align-items-center">
                <div className="col md-III">

                    <div className="container sm">
                        <Snippet code={colors} language='html' />
                    </div>

                </div>
                <div className="col md-III">

                    <div className="container sm">
                        <span className="badge dark">badge</span>
                        <span className="badge success">badge</span>
                        <span className="badge primary">badge</span>
                        <span className="badge info">badge</span>
                        <span className="badge danger">badge</span>
                        <span className="badge warning">badge</span>

                        <div className="spacer sm"></div>

                        <span className="badge gradient dark">badge</span>
                        <span className="badge gradient success">badge</span>
                        <span className="badge gradient primary">badge</span>
                        <span className="badge gradient info">badge</span>
                        <span className="badge gradient danger">badge</span>
                        <span className="badge gradient warning">badge</span>
                    </div>

                </div>
            </div>
        </div>
    </Fragment>
}

export default Badge